import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";
import React, { useState, useEffect } from "react";

const LatoRegular = require("../../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");
const HeartIcon = require("../../../Assets/Images/Heart-Icon.png");
const SoulIcon = require('../../../Assets/Images/SOUL.png')
const StrengthIcon = require('../../../Assets/Images/STRENGTH.png')
const MindIcon = require('../../../Assets/Images/MIND.png')

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  container: {
    gap: "20px",
    width: "100%",
  },
  title: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#426B88",
    textAlign: "left",
    lineHeight: "35px",
    height: "35px",
    marginBottom: "5px",
    fontFamily: "Lato",
  },
  row: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: "15px",
    width: "100%",
  },
  icon: {
    width: "78px",
    height: "78px",
    alignSelf: "flex-start",
  },
  section: {
    width: "100%",
    height: "79px",
    borderRadius: "5px",
    padding: "10px",
    backgroundColor: "#EAF1F5",
  },
  highlight: {
    fontSize: "12px",
    fontWeight: 700,
    color: "#00577D",
    textAlign: "left",
    lineHeight: "18px",
    marginLeft: "10px",
    fontFamily: "Lato",
  },
  text: {
    fontSize: "12px",
    lineHeight: "18px",
    color: "#00577D",
    fontWeight: "400",
    marginBottom: "0px",
  },
  textContainer: {
    flex: 1,
    justifyContent: "flex-start",
  },
  textPoints: {
    gap: "40px",
    height: "36px",
    color: "#00577D",
    fontWeight: "700",
    fontSize: "12px",
    lineHeight: "18px",
    flexDirection: "row",
    justifyContent: "left",
    marginLeft: "10px",
  },
  StrengthSection: {
    width: "100%",
    height: "166px",
    borderRadius: "5px",
    padding: "10px",
    gap: "10px",
    backgroundColor: "#F1F8F1",
  },
  ChallengeSection: {
    width: "100%",
    height: "166px",
    borderRadius: "5px",
    padding: "10px",
    gap: "10px",
    backgroundColor: "#FFF0EC",
  },
});

const HeartStarter = ({ apiData }) => {
    const [highestStarter, setHighestStarter] = useState('')
    const [variablsMapArray, setVariableMapArray] = useState()

    const pairs = [
      { round1: "heart_round1_m", round2: "heart_round2_m" },
      { round1: "soul_round1_m", round2: "soul_round2_m" },
      { round1: "str_round1_m", round2: "str_round2_m" },
      { round1: "mind_round1_m", round2: "mind_round2_m" }
    ];

    const variableMap = apiData?.variables?.reduce((acc, el) => {
      acc[el.variable] = el.score;
      return acc;
    }, {});
    
    useEffect(() => {
      if (variableMap) {
        setVariableMapArray(variableMap);
      }
    }, [apiData]);

    useEffect(() => {
        let highestScore = -Infinity;
        let highestVariable = "";
        let results = [];
        let labelsArray = [];
    
        if (variablsMapArray) {
          console.log(variablsMapArray);
          const heart_r1_m = variablsMapArray["heart_round1_m"] || 0;
          const soul_r1_m = variablsMapArray["soul_round1_m"] || 0;
          const mind_r1_m = variablsMapArray["mind_round1_m"] || 0;
          const strength_r1_m = variablsMapArray["str_round1_m"] || 0;
    
          const heart_r2_m = variablsMapArray["heart_round2_m"] || 0;
          const soul_r2_m = variablsMapArray["soul_round2_m"] || 0;
          const mind_r2_m = variablsMapArray["mind_round2_m"] || 0;
          const strength_r2_m = variablsMapArray["str_round2_m"] || 0;
    
          const heart_r1_l = variablsMapArray["heart_round1_l"] || 0;
          const soul_r1_l = variablsMapArray["soul_round1_l"] || 0;
          const mind_r1_l = variablsMapArray["mind_round1_l"] || 0;
          const strength_r1_l = variablsMapArray["str_round1_l"] || 0;
    
          const heart_r2_l = variablsMapArray["heart_round2_l"] || 0;
          const soul_r2_l = variablsMapArray["soul_round2_l"] || 0;
          const mind_r2_l = variablsMapArray["mind_round2_l"] || 0;
          const strength_r2_l = variablsMapArray["str_round2_l"] || 0;
    
          const heart_highest = Math.max(heart_r1_m, heart_r2_m, heart_r1_l, heart_r2_l);
          const mind_highest = Math.max(mind_r1_m, mind_r2_m, mind_r1_l, mind_r2_l);
          const soul_highest = Math.max(soul_r1_m, soul_r2_m, soul_r1_l, soul_r2_l);
          const strength_highest = Math.max(strength_r1_m, strength_r2_m, strength_r1_l, strength_r2_l);
          
    
          console.log("Heart Highest = " + heart_highest + "\nMind Highest = " + mind_highest + "\nSoul Highest = " + soul_highest + "\nStrength Highest = " + strength_highest);
          // let testingVarsM2 = [heart_r2 + heart_r1_m, soul_r2 + soul_round1_m, mind_r2 + mind_round1_m, strength_r2 + strength_round1_m];
          let testingVarsM2Pair = [{"name": "heart", "score": heart_highest},{"name": "soul", "score": soul_highest},{"name": "mind", "score": mind_highest}, {"name": "strength", "score": strength_highest}];
          console.log("testingVarsM2Pair",testingVarsM2Pair);
    
          highestVariable = testingVarsM2Pair.reduce((max, current) => 
            current.score > max.score ? current : max, { name: "", score: -Infinity }
          );
    
    
          let most_score = Math.max(heart_r1_m,soul_r1_m,mind_r1_m,strength_r1_m)
          let second_most_score = Math.max(heart_r2_m,soul_r2_m,mind_r2_m,strength_r2_m) / 2
          let least_score = Math.max(heart_r1_l,soul_r1_l,mind_r1_l,strength_r1_l)
          let second_least_score = Math.max(heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l) / 2
    
          console.log("heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l",heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l)
          if ( least_score >= second_least_score ) {
            least_score = ( second_least_score - 1 )
          }
    
          const total = most_score + second_most_score + least_score + second_least_score;
    
          const most_per = (most_score / total) * 100;
          const second_most_per = (second_most_score / total) * 100;
          const least_per = (least_score / total) * 100;
          const second_least_per = (second_least_score/ total) * 100 
    
          console.log("scores-",most_score,second_most_score,least_score,second_least_score)
          console.log("scores-per",most_per,second_most_per,least_score,second_least_per)
    
      
          let labels = testingVarsM2Pair.map(item => item.name);
    
          const labels_arr = ["heart", "soul", "mind", "strength"];
    
          const mostValues = [heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m];
          const secondMostValues = [heart_r2_m, soul_r2_m, mind_r2_m, strength_r2_m];
          const leastValues = [heart_r1_l, soul_r1_l, mind_r1_l, strength_r1_l];
          const secondLeastValues = [heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l];
    
          const most_score_label = Math.max(...mostValues);
          const second_most_score_label = Math.max(...secondMostValues);
          const least_score_label = Math.max(...leastValues);
          const second_least_score_label = Math.max(...secondLeastValues);
    
          const getLabel = (values, maxValue) => labels_arr[values.indexOf(maxValue)];
    
          const most_label = getLabel(mostValues, most_score_label);
          const second_most_label = getLabel(secondMostValues, second_most_score_label);
          const least_label = getLabel(leastValues, least_score_label);
          const second_least_label = getLabel(secondLeastValues, second_least_score_label);
    
          console.log(most_label , 'most_label')
          const getPercentageOrder = ( label ) => {
            if ( label == most_label?.toLowerCase() ) {
              return most_per;
            }
            if ( label == second_most_label?.toLowerCase() ) {
              return second_most_per;
            }
            if ( label == least_label?.toLowerCase() ) {
              return least_per;
            }
            if ( label == second_least_label?.toLowerCase() ) {
              return second_least_per;
            }
    
            return 0
          }
    
          console.log("scores- starter",most_score,second_most_score,least_score,second_least_score)
          console.log("scores-per-starter",most_per,second_most_per,least_score,second_least_per)
    
          // order should be most > second most > least > second least
          // results = [getPercentageOrder("mind"), getPercentageOrder("soul"), getPercentageOrder("strength"), getPercentageOrder("heart")] // label order = 'mind', 'soul', 'strength', 'heart'
          results = [getPercentageOrder("strength"), getPercentageOrder("heart"), getPercentageOrder("soul"), getPercentageOrder("mind")] // label order = 'mind', 'soul', 'strength', 'heart'
         
          // labelsArray = [...labelsArray, ...labels];
          // labelsArray = [least_label, second_least_label, second_most_label, most_label];
          labelsArray = ['mind', 'soul', 'strength', 'heart'];
    
          console.log('highestVariable', highestVariable)
          console.log("pie chart results", results);
          console.log("pie chart labelsArray", labelsArray);
    
          setHighestStarter(most_label);
          // setStarterScore(most_per);
          // setSnapshotResults(results);
          // setStarterLabel(labelsArray);
          // getMostAndSecondMostVaribale(apiData)
    
        }
    
      }, [variablsMapArray]);

  

    const getStarterHeading = () => {
      if (highestStarter?.includes("heart")) return "HEART STARTER";
      if (highestStarter?.includes("str")) return "STRENGTH STARTER";
      if (highestStarter?.includes("soul")) return "SOUL STARTER";
      if (highestStarter?.includes("mind")) return "MIND STARTER";
      else return "NONE";
    }
    const getStarterSections = () => {
      if (highestStarter?.includes("heart")) return "Heart";
      if (highestStarter?.includes("str")) return "Strength";
      if (highestStarter?.includes("soul")) return "Soul";
      if (highestStarter?.includes("mind")) return "Mind";
      else return "";
    }
    
    const getStarterLogo = () => {
      if (highestStarter?.includes("heart")) return HeartIcon;
      if (highestStarter?.includes("str")) return StrengthIcon;
      if (highestStarter?.includes("soul")) return SoulIcon;
      if (highestStarter?.includes("mind")) return MindIcon;
      else return "NONE";
    }

    const HighestStarterInfo = () => {
      if (highestStarter?.includes("heart")) return "Heart Starters are connection-oriented people who may lead with feelings, wants, passion, or desires. They are often motivated by the need to belong, which pushes them toward a deeper relationship with themselves and others."
      if (highestStarter?.includes("str")) return "Strength Starters are action-orientated and bring energy as doers, drivers, or managers. They are motivated by a forward movement that drives tangible results. They are usually direct, practical, resourceful, and efficient."
      if (highestStarter?.includes("soul")) return "Soul Starters are meaning-oriented, offering wisdom, deeper perspectives, and creativity in ways that may captivate and inspire others. They are motivated by vision-casting, stories, or metaphors in ways that reinforce the why behind any relationships or activities. They are often the contemplatives, sages, visionaries, creators, or innovators."
      if (highestStarter?.includes("mind")) return "Mind Starters are logically oriented and often grounded by structure, strategy, or planning. They will likely be motivated by learning, understanding, information, concepts, principles, and policies. They are the intellectuals, thinkers, engineers, designers, and strategists."
      else return ""
    }

    const StarterInfo2 = () => {
      if (highestStarter?.includes("heart")) return "“Capacity for Connection” is their fundamental point for action."
      if (highestStarter?.includes("str")) return "They steward a “Capacity for Service” to something greater than themselves."
      if (highestStarter?.includes("soul")) return " “Capacity for Meaning” is their context for everything else."
      if (highestStarter?.includes("mind")) return "“Capacity for Understanding” the big picture is a necessity."
      else return "";
    }

    const QueOne = () => {
      if (highestStarter?.includes("heart")) return "How does this make me feel?"
      if (highestStarter?.includes("str")) return "How will we do it?"
      if (highestStarter?.includes("soul")) return " Why are we doing this?"
      if (highestStarter?.includes("mind")) return "What do we need to know?"
      else return "";
    }
    const QueTwo = () => {
      if (highestStarter?.includes("heart")) return "Who do I need by my side?"
      if (highestStarter?.includes("str")) return "How can I win?"
      if (highestStarter?.includes("soul")) return " What’s the deeper purpose behind this?"
      if (highestStarter?.includes("mind")) return "What’s the plan?"
      else return "";
    }
    const QueThree = () => {
      if (highestStarter?.includes("heart")) return "Who will this help?"
      if (highestStarter?.includes("str")) return "How can we gain momentum?"
      if (highestStarter?.includes("soul")) return " Why is this important?"
      if (highestStarter?.includes("mind")) return "What do you think?"
      else return "";
    }
    const QueFour = () => {
      if (highestStarter?.includes("heart")) return "How will this impact me emotionally?"
      if (highestStarter?.includes("str")) return "What do I practically need to make this happen?"
      if (highestStarter?.includes("soul")) return " What impact will this have on a greater scale?"
      if (highestStarter?.includes("mind")) return "What steps need to happen?"
      else return "";
    }

    const StrengthsSection = () => {
      if (highestStarter?.includes("heart")) return "Heart Starters lean into their lives in order to connect with people, feelings, wants, and desires. They seek to commune and share their lives with others out of a strong motivation to belong. Heart Starters may bring the passionate call for others to gather, join, or collaborate. Anchored in “being” rather than “doing,” they have this knack for recognizing and elevating someone's worth beyond their output or what they can offer. Heart Starters, you are a catalyst for connection and a culture carrier. You have a unique capacity to awaken a connection with the people and things that matter most and to invite people into more of their lives."
      if (highestStarter?.includes("str")) return " Strength Starters are a driving force, turning ideas into action. They are quick, resourceful, efficient, and direct, instinctively tackling challenges, gathering resources, and leading the way. Their greatest strength is their ability to serve a purpose larger than themselves."
      if (highestStarter?.includes("soul")) return " Soul Starters thrive on vision and deep meaning, using stories, inventions, symbols, and metaphors to captivate and inspire. Their unique ability to see beyond the surface allows them to offer wise counsel and reframe challenges with clarity. Often serving as mentors, coaches, and counselors, they excel in developing and supporting others."
      if (highestStarter?.includes("mind")) return "They bring things like plans, policies, principles, and beliefs to the forefront of their approach and considerations. Mind Starters often find energy and fulfillment in their analytic problem-solving abilities. They have a unique ability to simplify complex problems and break them down into manageable pieces. Although their communication style may be more factual and less emotive, its clarity, organization, and focus on strategic outcomes make it profoundly effective."
      else return "";
    }

    const ChallengesSection = () => {
      if (highestStarter?.includes("heart")) return "Heart Starters may become overly attached to their feelings, seek to please others at the expense of their own mission, or become mired in introspection and inactivity. Just as a rose is beautiful and fragrant but has thorns, Heart Starters have the beauty of empathy and the pain of being easily wounded or taking on too much emotional burden."
      if (highestStarter?.includes("str")) return "They may disconnect from relationships, meaning, and emotion to become harsh taskmasters. Their sense of urgency may lead them to act prematurely and without a well-formed plan, the consequences of which are then felt tangibly throughout the whole organization or family unit."
      if (highestStarter?.includes("soul")) return "Soul Starters may isolate themselves in the world of ideas, withdraw when they feel invalidated or misunderstood, or seek safety in exploration without choosing to act. Their natural insight can sometimes lead to pride or elitism, and they may become overly idealistic. They may avoid relationships that require a lot of work or create unnecessary anxiety and tension. Driven by vision, they often struggle with details and routine tasks, finding them challenging to follow through on."
      if (highestStarter?.includes("mind")) return "Mind Starters can become so focused on perfecting their systems and strategies that they may overlook the people they serve. They can come across as cold and calculating or lacking empathy and understanding, especially in emotionally charged situations. Their pursuit of additional data can delay progress, and they may become overwhelmed by the sheer volume of information, struggling to organize or communicate it effectively."
      else return "";
    } 

  return (
    <View style={styles.container}>
      <Text style={styles.title}>YOU ARE A {getStarterHeading()}</Text>

      {/* Image + Text in One Row */}
      <View style={styles.row}>
        <Image src={getStarterLogo()} style={styles.icon} />
        <View style={styles.textContainer}>
          <Text style={styles.text}>
            {HighestStarterInfo()}
          </Text>
          <Text style={styles.text}>
            {StarterInfo2()}
          </Text>
        </View>
      </View>

      {/* Heart Starter Questions */}
      <View style={styles.section}>
        <Text style={styles.highlight}>{getStarterSections()} Starters often ask:</Text>
        <View style={styles.textPoints}>
          <View>
            <Text>• {QueOne()}</Text>
            <Text>• {QueTwo()}</Text>
          </View>
          <View>
            <Text>• {QueThree()}</Text>
            <Text>• {QueFour()}</Text>
          </View>
        </View>
      </View>

      {/* Strengths Section */}
      <View style={styles.StrengthSection}>
        <Text style={styles.highlight}>Strengths:</Text>
        <Text style={styles.text}>
          {StrengthsSection()}
        </Text>
      </View>

      {/* Challenges Section */}
      <View style={styles.ChallengeSection}>
        <Text style={styles.highlight}>Challenges:</Text>
        <Text style={styles.text}>
          {ChallengesSection()}
        </Text>
      </View>
    </View>
  );
};

export default HeartStarter;
